module.exports = __webpack_public_path__ + "img/hongbao-index.30fe637f.jpg";